export default __webpack_public_path__ + "static/youtube-6758c7256e697ff68127087c0063e4d1.svg";